import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

export const getCateringOrderStatus = async (orderNo, referenceNumber = "") => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.CATERING_ORDER_STATUS, {
      order_no: orderNo,
      reference_number: referenceNumber || ""
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching catering order status:", error);
    throw error;
  }
};
